module.exports = __webpack_public_path__ + "img/logo-fr.ce62d082.png";